import * as TonalChord from '@tonaljs/chord';

/**
 * Finds chords that contain the given notes
 * @param notes - Array of note names
 * @returns Array of possible chord names
 */
export function findChords(notes: string[]): string[] {
  return TonalChord.detect(notes);
}
